import API, { API as APIService } from './API';

const path = `provas`;

const ProvaService = {
    filters: async filters => await API.filters(path, filters),
    list: async () => await API.list(path),
    find: async id => await API.find(path, id),
    add: async prova => await API.add(path, prova),
    remove: async id => await API.remove(path, id),
    downloadCartao: async id => await API.download(`${path}/${id}/cartao/download`),    
    addComCartao: async (formData, config) => await APIService.post(`${path}/com-cartao`, formData, config),
    podeDigitarAlternativamente: async id => await APIService.get(`${path}/${id}/pode-digitar-alternativamente`),
    carregarDigitacao: async id => await APIService.get(`${path}/${id}/digitacao`),
    digitarAlternativamente: async (id, payload) => await APIService.post(`${path}/${id}/digitar-alternativamente`, payload),
    revisarAlternativamente: async (id, payload) => await APIService.post(`${path}/${id}/digitar-alternativamente`, payload),
    vincularCandidato: async (id, payload) => await APIService.post(`${path}/${id}/vincular-candidato`, payload),
    substituirCartao: async (id, formData, config) => await APIService.post(`${path}/${id}/cartao/substituir`, formData, config),
    trocarCandidatos: async payload => await APIService.post(`${path}/trocar-candidatos`, payload),
    invalidas: async filters => await API.filters(`${path}/invalidas`, filters),
    tratarInvalida: async (id, payload) => await APIService.post(`${path}/invalidas/${id}/tratamento`, payload),
}

export default ProvaService;
